__turbopack_context__.v({
  "container": "MediaCoverageTeaser-module-scss-module__rR6McW__container",
  "coverageItem": "MediaCoverageTeaser-module-scss-module__rR6McW__coverageItem",
  "coverageList": "MediaCoverageTeaser-module-scss-module__rR6McW__coverageList",
  "links": "MediaCoverageTeaser-module-scss-module__rR6McW__links",
  "logo": "MediaCoverageTeaser-module-scss-module__rR6McW__logo",
  "readMore": "MediaCoverageTeaser-module-scss-module__rR6McW__readMore",
});
